import {
  Icon,
  Box
} from "@chakra-ui/react";
import { IconType } from "react-icons";

import { Text } from "src/components/text";

interface QuickActionBoxProps {
  handleClick: () => void;
  Icon: IconType;
  text: string
}

export const QuickActionBox: React.FC<QuickActionBoxProps> = props => {
  return (
    <Box
      display="flex"
      paddingX={10}
      cursor="pointer"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      onClick={props.handleClick}
    >
      <Icon
        w={18}
        h={18}
        mb={2}
        as={props.Icon}
      />

      <Text as="p">
        {props.text}
      </Text>
    </Box>
  );
};